import iamotaAjax from 'scripts/helpers/iamota-ajax';
var baseUrl = window.Shopify.routes.root;
var product = {
  /**
   * Fetches product details based on the product handle.
   * @param {string} handle - The product handle.
   * @returns {Promise} - The result of the AJAX get request.
   */
  fetch: handle => {
    return iamotaAjax.get("".concat(baseUrl, "products/").concat(handle, ".js"), 'Shopify:product');
  }
};
export default product;